import { createClient } from "@/shared/urql/urql";
import { GetCurrentUserDocument } from "@/shared/generated/graphql";
import { handleCombinedError } from "@/shared/helper/handleCombinedError.helper";
import { translateError } from "@/shared/helper/translateError.helper";

export const getCurrentUser = async () => {
  const client = createClient();

  const { error, data } = await client
    .query(GetCurrentUserDocument, {})
    .toPromise();

  if (error) throw handleCombinedError(error);
  if (!data) throw translateError("INTERNAL_ERROR");

  return data.currentUserV2;
};
